<div class="menu">
    <span class="menu-heading"> {{title}}</span>
  <!--<span class="close" (click)="closeTaskSelectionMenu()">X</span>-->
</div>

<div class="console">
  <div class="row" style="margin: 0.313rem">
    <div class="col-3 at-lable-text">Recipient:</div>
    <div class="col at-lable-value">{{step2Hdr1Text}}</div>
  </div>

  <div class="row" style="margin: 0.313rem">
    <div class="col-3 at-lable-text">On Call:</div>
    <div class="col at-lable-value">{{step2Hdr2Text}}</div>
  </div>

  <hr class="at-separator" />

  <div class="at-lable-text-center">On with Transfer</div>

  <div class="text-center">
    <button class="btn submit" type="submit" [disabled]="!Getdata('step2ToggleBtn_enabled')" style="margin-right: 0.313rem; text-align: center">Toggle Line</button>
  </div>

  <div class="col at-lable-value-center"><div class="bold"> {{Getdata('step2ToggleCaller')}}</div></div>

  <div class="at-options">When you are ready,choose one of the following options</div>
  <div class="text-center">
      <button class="btn submit text-center" [disabled]="!Getdata('step2CompleteBtn_enabled')" (click)="eStep2CompleteBtnClickHandler()" type="submit" style="margin-right: 0.313rem">
          Complete Transfer
      </button>
  </div>
  <div class="text-center">
    <button class="btn submit text-center" [disabled]="!Getdata('step2VoicemailBtn_enabled')" type="submit" style="margin-right: 0.313rem">Send to Voicemail</button>
  </div>
  <div class="text-center">
    <button class="btn submit text-center cancel-btn"  type="submit" (click)="closeTaskSelectionMenu()">Cancel Transfer</button>
  </div>
</div>
